import { render, staticRenderFns } from "./SaisiePaginationTab.vue?vue&type=template&id=4574377c"
import script from "./SaisiePaginationTab.vue?vue&type=script&lang=js"
export * from "./SaisiePaginationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4574377c')) {
      api.createRecord('4574377c', component.options)
    } else {
      api.reload('4574377c', component.options)
    }
    module.hot.accept("./SaisiePaginationTab.vue?vue&type=template&id=4574377c", function () {
      api.rerender('4574377c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Saisie/SaisiePaginationTab.vue"
export default component.exports